import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 10v2a7 7 0 0 0 12 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 9v3a3 3 0 0 0 5.12 2.12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "19", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MicOff";
const MicOff = memo(themed(Icon));
export {
  MicOff
};
//# sourceMappingURL=mic-off.js.map
